import React, { Fragment, Suspense, useMemo } from 'react';
import styled from '@emotion/styled';
import { AppContextType, DESKTOP_MEDIAQUERY } from '@embed/components/helpers';
import { useTranslation } from '@embed/hooks/react-i18nextLazy';
import Grid from './Grid';
import { PlaylistVideoPlayer } from './PlaylistVideoPlayer';
const VideoPlayer = React.lazy(() => import('@embed/components/VideoPlayer'));
const Container = styled('div') `
  font-size: 12px;
  line-height: 1.2;

  & a,
  & button {
    -webkit-tap-highlight-color: transparent;
  }
`;
const Wrapper = styled.div `
  color: white;
  font-family: var(--font-family);
  font-weight: normal;

  ${(props) => props.mode === 'pinned' &&
    `
    background: black;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    padding: 5px 0;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;

    overflow: hidden;
    z-index: 2147483646 !important;

    @media only screen and (${DESKTOP_MEDIAQUERY}) {
      border-radius: 12px 12px 0 0;
      left: 50%;
      width: 60vw;
      transform: translateX(-50%);
    }
  `};
  ${(props) => props.mode === 'row' &&
    `
    position: relative;
  `}
`;
const Title = styled('div') `
  font-size: 28px;
  font-weight: 500;
  margin: 0;
  padding-bottom: 10px;
  padding: 20px 10px;
`;
export default (props) => {
    const { appContext, params, player, actions, videos, fetchMoreVideos } = props;
    const { mode } = params;
    const { t } = useTranslation();
    const appContextEmbed = useMemo(() => {
        var _a;
        return (Object.assign(Object.assign({}, appContext), { appContextType: AppContextType.EMBED_CONTEXT_TYPE, isInIframe: params.in_iframe, pageUrl: params.page_url, publisherAppId: params.app_id, publisherClientId: appContext.publisherClientId, variant: (_a = player.video) === null || _a === void 0 ? void 0 : _a.variant }));
    }, [appContext, player.video, params]);
    const title = params.title !== undefined ? params.title : t('Stories and Short Videos');
    return (<Container className="fwn-grid" dir={params.dir}>
      {mode === 'grid' && (<Title className="cy-title" role="presentation">
          {title}
        </Title>)}

      <Wrapper className="cy-grid" aria-hidden={player.isOpen} mode={mode} aria-label={title} role="application">
        <Grid {...props}/>
      </Wrapper>

      {player.isOpen && player.video && (<Suspense fallback={<Fragment />}>
          <VideoPlayer actions={actions} appContext={appContextEmbed} onClose={actions.hideVideoPlayer} params={params} videos={videos} video={player.video} muted={player.muted} triggerFetchNextVideos={fetchMoreVideos}/>
        </Suspense>)}

      {player.isOpen && player.playlist && (<PlaylistVideoPlayer actions={actions} appContext={appContextEmbed} params={params} playlist={player.playlist} muted={player.muted}/>)}
    </Container>);
};
